import {
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';

import { get, putRequest } from '../../../utils/request';
import makeSelectMain from '../../Main/selectors';
import {
  changeStep,
  closeModalState,
  fetchAlertSettingsFailure,
  fetchAlertSettingsSuccess,
  fetchPaperlessSettingAllFailure,
  fetchPaperlessSettingAllSuccess,
  putAlertSettingsFailure,
  putAlertSettingsSuccess,
  putPaperlessSettingFailure,
  putPaperlessSettingSuccess,
} from './actions';
import {
  FETCH_ALERT_SETTINGS,
  FETCH_ALERT_SETTINGS_ERROR_MESSAGE,
  FETCH_PAPERLESS_SETTING_ALL,
  FETCH_PAPERLESS_SETTING_ALL_ERROR_MESSAGE,
  PUT_ALERT_SETTINGS,
  PUT_ALERT_SETTINGS_ERROR_MESSAGE,
  PUT_PAPERLESS_SETTING,
  PUT_PAPERLESS_SETTING_ERROR_MESSAGE,
} from './constants';
import makeSelectCommunications, { selectFormAlertSettings } from './selectors';

export function* fetchAlertSettingsSaga({ baseUrl }) {
  try {
    const loanNumber = yield select(makeSelectMain('selectedLoan'));
    const endpoint = `${baseUrl}/settings/${loanNumber}/alerts`;
    const { currentSetting, profile } = yield call(get, endpoint);
    yield put(fetchAlertSettingsSuccess({ currentSetting, profile }));
  } catch {
    yield put(fetchAlertSettingsFailure(FETCH_ALERT_SETTINGS_ERROR_MESSAGE));
  }
}

export function* fetchPaperlessSettingAllSaga({ baseUrl }) {
  try {
    const endpoint = `${baseUrl}/settings/paperless`;
    const { currentPaperlessSettings } = yield call(get, endpoint);
    yield put(fetchPaperlessSettingAllSuccess(currentPaperlessSettings));
  } catch {
    yield put(fetchPaperlessSettingAllFailure(FETCH_PAPERLESS_SETTING_ALL_ERROR_MESSAGE));
  }
}

export function* putAlertSettingsSaga({ baseUrl }) {
  try {
    const loanNumber = yield select(makeSelectMain('selectedLoan'));
    const formAlertSettings = yield select(selectFormAlertSettings());
    const endpoint = `${baseUrl}/settings/${loanNumber}/alerts`;
    const { error } = yield call(putRequest, endpoint, { newSetting: formAlertSettings });
    if (error) {
      /*
        The way our form ui is set up should prevent partial errors from
        happening. If for some reason one does, we'll treat as a full error.
      */
      throw new Error();
    } else {
      yield put(putAlertSettingsSuccess());
    }
  } catch {
    yield put(putAlertSettingsFailure(PUT_ALERT_SETTINGS_ERROR_MESSAGE));
  }
  yield put(changeStep(2));
}

export function* putPaperlessSettingSaga({ baseUrl }) {
  try {
    const selectedLoan = yield select(makeSelectCommunications('selectedLoan'));
    const formPaperlessSettings = yield select(makeSelectCommunications('formPaperlessSettings'));
    const { status } = formPaperlessSettings[selectedLoan];
    const requestedOperation = status === 'Enabled' ? 'Request_Enable' : 'Request_Disable';
    const endpoint = `${baseUrl}/settings/${selectedLoan}/paperless`;
    const { error } = yield call(putRequest, endpoint, { requestedOperation });
    if (error) {
      /*
        The way our form ui is set up should prevent partial errors from
        happening. If for some reason one does, we'll treat as a full error.
      */
      throw new Error();
    } else {
      yield put(putPaperlessSettingSuccess());
    }
  } catch {
    yield put(putPaperlessSettingFailure(PUT_PAPERLESS_SETTING_ERROR_MESSAGE));
  }
  yield put(changeStep(3));
  yield put(closeModalState());
}

export default (options) => function* watcherSaga() {
  yield all([
    takeLatest(FETCH_ALERT_SETTINGS, fetchAlertSettingsSaga, options),
    takeLatest(FETCH_PAPERLESS_SETTING_ALL, fetchPaperlessSettingAllSaga, options),
    takeLatest(PUT_ALERT_SETTINGS, putAlertSettingsSaga, options),
    takeLatest(PUT_PAPERLESS_SETTING, putPaperlessSettingSaga, options),
  ]);
};
